/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharactersmathematical
 */
import Plugin from '@src/plugins/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Mathematical" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersMathematical ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersMathematical extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Mathematical', [
            {
                character: '<',
                title: t('bl')
            },
            {
                character: '>',
                title: t('bm')
            },
            {
                character: '\u2264',
                title: t('bn')
            },
            {
                character: '\u2265',
                title: t('bo')
            },
            {
                character: '\u2013',
                title: t('bp')
            },
            {
                character: '\u2014',
                title: t('bq')
            },
            {
                character: '\xAF',
                title: t('br')
            },
            {
                character: '\u203E',
                title: t('bs')
            },
            {
                character: '\xB0',
                title: t('bt')
            },
            {
                character: '\u2212',
                title: t('bu')
            },
            {
                character: '\xB1',
                title: t('bv')
            },
            {
                character: '\xF7',
                title: t('bw')
            },
            {
                character: '\u2044',
                title: t('bx')
            },
            {
                character: '\xD7',
                title: t('by')
            },
            {
                character: 'ƒ',
                title: t('bz')
            },
            {
                character: '\u222B',
                title: t('ca')
            },
            {
                character: '\u2211',
                title: t('cb')
            },
            {
                character: '\u221E',
                title: t('cc')
            },
            {
                character: '\u221A',
                title: t('cd')
            },
            {
                character: '\u223C',
                title: t('ce')
            },
            {
                character: '\u2245',
                title: t('cf')
            },
            {
                character: '\u2248',
                title: t('cg')
            },
            {
                character: '\u2260',
                title: t('ch')
            },
            {
                character: '\u2261',
                title: t('ci')
            },
            {
                character: '\u2208',
                title: t('cj')
            },
            {
                character: '\u2209',
                title: t('ck')
            },
            {
                character: '\u220B',
                title: t('cl')
            },
            {
                character: '\u220F',
                title: t('cm')
            },
            {
                character: '\u2227',
                title: t('cn')
            },
            {
                character: '\u2228',
                title: t('co')
            },
            {
                character: '\xAC',
                title: t('cp')
            },
            {
                character: '\u2229',
                title: t('cq')
            },
            {
                character: '\u222A',
                title: t('cr')
            },
            {
                character: '\u2202',
                title: t('cs')
            },
            {
                character: '\u2200',
                title: t('ct')
            },
            {
                character: '\u2203',
                title: t('cu')
            },
            {
                character: '\u2205',
                title: t('cv')
            },
            {
                character: '\u2207',
                title: t('cw')
            },
            {
                character: '\u2217',
                title: t('cx')
            },
            {
                character: '\u221D',
                title: t('cy')
            },
            {
                character: '\u2220',
                title: t('cz')
            },
            {
                character: '\xBC',
                title: t('da')
            },
            {
                character: '\xBD',
                title: t('db')
            },
            {
                character: '\xBE',
                title: t('dc')
            }
        ]);
    }
}